import Button from "src/components/shared/Button";
import { ReactComponent as StopwatchSvg } from "src/images/stopwatch.svg";
import { ReactComponent as PieTimerSVG } from "src/images/timer-icons/pie-timer.svg";
import { media } from "src/styles/mixins";
import { ThemeType } from "src/styles/theme";
import styled, { css, keyframes } from "styled-components";

interface TimerWrapperProps {
  canInteract: boolean;
  isActive: boolean;
}

export const TimerWrapper = styled.div<TimerWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;
  padding: 8px;

  border-radius: 50%;

  box-shadow: ${({ theme, isActive }) =>
    `0px 0px 0px ${isActive ? 4 : 2}px${theme.colors.primary}`};
  transition: box-shadow 0.1s ease;
  user-select: none;

  @media ${({ theme }) => theme.mq.md} {
    width: 64px;
    height: 64px;
  }

  ${({ canInteract }) =>
    canInteract &&
    css`
      cursor: pointer;

      &:hover {
        box-shadow: 0px 0px 0px 4px;
      }
    `}
`;

export const RestartTimer = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.s};
  color: ${({ theme }) => theme.colors.link};
  font-weight: ${({ theme }) => theme.fonts.weights.bolder};
  margin-left: 45px;
  cursor: pointer;
`;

export const StartTimerButton = styled(Button)`
  width: 100%;
`;

export const TimerMenu = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const TimerMenuItem = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    margin-right: 14px;
  }
`;

export const StopWatchIcon = styled(StopwatchSvg)`
  width: 75%;
  height: 75%;
`;

export const PieTimer = styled(PieTimerSVG)<{
  $animationDurationInMs: number;
  $elapsedTimeInMs: number;
}>`
  width: 100%;
  height: 100%;

  circle {
    fill: none;
    stroke: ${({ theme }) => theme.colors.background};
  }

  path {
    stroke-linecap: butt;
    stroke-dasharray: 157.08, 157.08;
    stroke-dashoffset: 0;
    stroke-width: 50;
    fill-opacity: 0;

    animation-name: ${({ theme }) => getPieTimerAnimation(theme)};
    animation-duration: ${({ $animationDurationInMs }) =>
      `${$animationDurationInMs}ms`};
    animation-timing-function: linear;
    animation-delay: ${({ $elapsedTimeInMs }) => `-${$elapsedTimeInMs}ms`};
  }
`;

const getPieTimerAnimation = (theme: ThemeType) => keyframes`
    0% {
        stroke-dashoffset: 0;
        stroke: ${theme.colors.timer.start};
    }
    50% {
        stroke-dashoffset: -78.9;
        stroke: ${theme.colors.timer.mid};
    }
    75% {
        stroke-dashoffset: -117.81;
        stroke: ${theme.colors.timer.end};
    }
    100% {
        stroke-dashoffset: -157.08;
        stroke: ${theme.colors.timer.end};
    }
`;

export const timerMenuWrapperStyles = css`
  max-width: 325px;
  padding: 32px;
`;

export const timerEndedTooltipWrapperStyles = css`
  max-width: 216px;

  ${media.up("MOBILE")`
      max-width: 260px;
  `};
`;
